import { Routes } from '@angular/router';
import { StatistiekenComponent } from './statistieken/statistieken.component';
import { SpoedComponent } from './spoed/spoed.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from '../app/services/authentication/auth.guard';
import { ItComponent } from './it/it.component';

export const routes: Routes = [
  { path: 'statistieken', component: StatistiekenComponent, canActivate: [AuthGuard] },
  { path: 'spoed', component: SpoedComponent, canActivate: [AuthGuard] },
  { path: 'it', component: ItComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  {path: '**', redirectTo: 'login'}
];
